import React from 'react'
import useFilters from '@byma/shared/hooks/useFilters'
import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import Router, { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import Layout from 'components/Layout'
import { methodParser, money } from '@byma/shared/helpers/formatters'
import useAuth from '@byma/shared/hooks/useAuth'
import { FiCopy, FiArrowLeft, FiArrowRight, FiArrowLeftCircle } from 'react-icons/fi'
import { ImWhatsapp } from 'react-icons/im'
import useSWR from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'
import TicketsTable from 'components/TicketsTable'

export const statusParser = {
    paid: 'Pago',
    pending: 'Pendente',
    canceled: 'Cancelado',
    // Custom parser so rename is possible
    refunded: 'Cancelado',
    expired: 'Expirado',
    refused: 'Não autorizado',
    errored: 'Erro',
    'order placed': 'Pendente',
    POS: 'Pago'
}

const checkinStatusParser = {
    'TicketNotUsed': 'Ingresso ainda não utilizado',
    'TicketTypeDisabled': 'Lote desabilitado',
    'TicketUsed': 'Ingresso já utilizado',
    'TicketRefunded': 'Ingresso estornado',
    'TicketUnderAnalysis': 'Ingresso em análise',
    'TicketNotFound': 'Ingresso não encontrado',
    'TicketNotValid': 'Ingresso não válido',
    'TicketAlreadyUsed': 'Ingresso já utilizado',
}

export default function Tickets() {

    const session = useAuth()
    let { query, ...router } = useRouter()
    const { ticketId } = query
    const { token, user: currentUser } = session

    const { data: ticketSelected } = useSWR(token && ticketId ? ['/api/tickets/get?ticketId=' + ticketId, null, token] : null, fetcher)

    const { originalQueryString } = useFilters(query)

    const ticketHistory = React.useMemo(() => {
        let result = []

        if (ticketSelected) {
            ticketSelected.result.changelog?.map(({ date, content }, index) => {
                const lastContent = index === 0 ? ticketSelected.result : ticketSelected.result.changelog[index - 1].content
                result.push({
                    date,
                    diff: diff(lastContent, content)
                })
            })
        }
        return result
    }, [ticketSelected])

    return (
        <Layout {...{ session }}>
            <div className="flex divide-x-0 lg:divide-x gap-3 h-full">
                {/*    <div className={`flex flex-col ${ticketSelected || ticketId ? 'hidden lg:block' : 'lg:block'} w-full lg:w-1/2 p-3`}>*/}
                <div className="w-full">
                    <TicketsTable />
                </div>
                <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${ticketId ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => router.push(`/tickets?${originalQueryString}`)}>
                    <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                    <div class="modal-content p-3 absolute bg-white w-full md:w-11/12 md:max-w-2xl md:mx-auto md:rounded md:shadow-lg z-50 overflow-y-auto max-h-screen" onClick={(e) => e.stopPropagation()}>
                        <div className="flex justify-end">
                            <Link href={`/tickets?${originalQueryString}`}>
                                <a>
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </a>
                            </Link>
                        </div>
                        {ticketSelected ? (
                            <>
                                <div className="mb-6">
                                    <div className="mb-3">
                                        {ticketSelected?.result?.ticketType?.partyId?.pictures?.photos[0] ? (
                                            <img src={ticketSelected?.result?.ticketType?.partyId?.pictures.photos[0]} alt={ticketSelected?.result?.ticketType?.partyId?.name} className="rounded h-32 object-cover w-full" />
                                        ) : (
                                            <div className="h-32 bg-gray-400 rounded overflow-hidden" />
                                        )}
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <p className="text-xl font-bold">Ingresso #{ticketSelected.result._id}</p>
                                        <p className="text-gray-700">{dayjs(ticketSelected.result.dateBought).format('DD/MM/YYYY hh:mm:ss')}</p>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="min-w-0 text-left">
                                                <p className="text-md font-bold">Evento</p>
                                                <p className="truncate">
                                                    {ticketSelected?.result?.ticketType?.partyId?.name || 'N/A'}
                                                </p>
                                                <p className="truncate">
                                                    {ticketSelected?.result?.ticketType?.partyId?._id || 'N/A'}
                                                </p>
                                            </div>
                                            <div className="min-w-0 text-right">
                                                <p className="text-md">{dayjs(ticketSelected?.result?.ticketType?.partyId?.date).format('DD/MM/YYYY HH:mm:ss')}</p>
                                                <p className="text-xs">
                                                    {ticketSelected?.result?.ticketType?.partyId?.location?.name|| 'N/A'} - {ticketSelected?.result?.ticketType?.partyId?.location?.address || 'N/A'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="text-left min-w-0">
                                                <p className="text-md font-bold">Lote</p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-md">{ticketSelected.result?.ticketType?.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="text-left min-w-0">
                                                <p className="text-md font-bold">Status</p>
                                            </div>
                                            <div className="text-right">
                                                <p className={`label text-center ${ticketSelected.result.status === 'refunded' ? '' : 'success'}`}>{statusParser[ticketSelected.result.status]}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="text-left min-w-0">
                                                <p className="text-md font-bold">Fatura</p>
                                                <p className="text-md">Total {money(ticketSelected.result?.orderId?.total)}</p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-md">{ticketSelected.result?.orderId?.token}</p>
                                                <Link href={`/orders/${ticketSelected.result.orderId.token}`}>
                                                    <a className="text-blue-700 hover:underline">
                                                        Ir para fatura
                                                    </a>
                                                </Link>

                                            </div>
                                        </div>
                                    </div>
                                    { ticketSelected?.result?.created_by && (
                                        <div className="box w-full mt-6">
                                            <div className="min-w-0 text-left">
                                                <p className="text-md font-bold">Criado por</p>
                                                <p className="truncate">
                                                    {ticketSelected?.result?.created_by?.profile?.name || 'Usuário não associado'}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    <div className="box w-full mt-6">
                                        <div className="flex justify-between items-center">
                                            <div className="min-w-0 text-left">
                                                <p className="text-md font-bold">Usuário associado</p>
                                                <p className="truncate">
                                                    {ticketSelected?.result?.owner?.profile?.name || 'Usuário não associado'}
                                                </p>
                                            </div>
                                            <div className="min-w-0 text-right">
                                                <p className="truncate">
                                                    {ticketSelected?.result?.owner?.email}
                                                </p>
                                                <p className="truncate">
                                                    {ticketSelected?.result?.owner?.profile.cpf}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="text-left">
                                            <p className="text-md font-bold">Transferências</p>
                                        </div>
                                        <div className="mt-3">
                                            {ticketSelected.result.transfers.length === 0 && (
                                                <p>Nenhuma transferência realizada</p>
                                            )}
                                            {ticketSelected.result.transfers?.map((confirmation, index) => (
                                                <div className="box">
                                                    <div className="border-b pb-1 mb-2">
                                                        <p className="text-sm tracking-tight">
                                                            Solicitada em {dayjs(confirmation.created_at).format('DD/MM/YYYY HH:mm')}
                                                        </p>
                                                    </div>
                                                    <div className="grid grid-cols-5 space-x-3 items-center">
                                                        <div className="flex items-center justify-start space-x-2 col-span-2">
                                                            <div>
                                                                {confirmation.oldUser?.profile?.picture ? (
                                                                    <div className="rounded-full w-4 h-4 min-w-0 overflow-hidden">
                                                                        <img src={confirmation.oldUser.profile.picture} alt={""} className="rounded-full w-4 h-4 object-cover" width={20} height={20} />
                                                                    </div>
                                                                ) : (
                                                                    <div className="w-4 h-4 rounded-full bg-gray-400 overflow-hidden min-w-0" />
                                                                )}
                                                            </div>
                                                            <div>
                                                                <p className="text-md text-gray-700 truncate tracking-tight">
                                                                    {confirmation.oldUser?.profile?.name || 'Usuário não associado'}
                                                                </p>
                                                                <p className="text-md text-gray-700 truncate tracking-tight">
                                                                    {confirmation.oldUser?.email || ''}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center justify-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                            </svg>
                                                        </div>
                                                        <div className="flex items-center justify-end space-x-2 col-span-2">
                                                            <div>
                                                                {confirmation.newUser?.profile?.picture ? (
                                                                    <div className="rounded-full w-4 h-4 min-w-0 overflow-hidden">
                                                                        <img src={confirmation.newUser.profile.picture} alt={""} className="rounded-full w-4 h-4 object-cover" width={20} height={20} />
                                                                    </div>
                                                                ) : (
                                                                    <div className="w-4 h-4 rounded-full bg-gray-400 overflow-hidden min-w-0" />
                                                                )}
                                                            </div>
                                                            <div>
                                                                <p className="text-md text-gray-700 truncate tracking-tight">
                                                                    {confirmation.newUser?.profile?.name || 'Usuário não associado'}
                                                                </p>
                                                                <p className="text-md text-gray-700 truncate tracking-tight">
                                                                    {confirmation.newUser?.email || ''}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="text-left">
                                            <p className="text-md font-bold">Check-ins</p>
                                        </div>
                                        <div className="mt-3">
                                            {ticketSelected.result.validations?.length === 0 && (
                                                <p>Nenhum check-in realizado</p>
                                            )}
                                            {ticketSelected.result.validations?.map((confirmation, index) => (
                                                <div className="box">
                                                    <div className="flex justify-between space-x-3">
                                                        <p>{dayjs(confirmation.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                                        <p className={`label ${confirmation.success ? 'success' : 'error'}`}>
                                                            {confirmation.success ? 'Sucesso' : (checkinStatusParser[confirmation.denyReason] || confirmation.denyReason)}
                                                        </p>
                                                    </div>
                                                    <div className="flex justify-between space-x-3">
                                                        <p>{confirmation.direction === 'in' ? 'Entrada' : 'Saída' }</p>
                                                    </div>
                                                    <div className="flex justify-between space-x-3">
                                                        <p>{confirmation.gatewaySessionId.name}</p>
                                                        <div className="flex space-x-1 items-center">
                                                            <p className="text-md text-gray-700 truncate">
                                                                Validado por {confirmation.created_by?.profile?.name || 'Usuário não associado'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="box w-full mt-6">
                                        <div className="text-left">
                                            <p className="text-md font-bold">Histórico</p>
                                        </div>
                                        <div className="mt-3">
                                            {ticketHistory?.map((history, index) => (
                                                <div className="flex justify-between">
                                                    <p>{dayjs(history.date).format('DD/MM/YYYY HH:mm')}</p>
                                                    {index === 0 && (
                                                        <p>Ticket criado</p>
                                                    )}
                                                    {index !== 0 && (
                                                        <p></p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="w-full py-12">
                                <Loader /> 
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

function diff(obj1, obj2) {
    if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
        return obj1;
    }
    var diffs = {};
    var key;

    var arraysMatch = function (arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }
        return true;

    };

    var compare = function (item1, item2, key) {
        var type1 = Object.prototype.toString.call(item1);
        var type2 = Object.prototype.toString.call(item2);
        if (type2 === '[object Undefined]') {
            diffs[key] = null;
            return;
        }
        if (type1 !== type2) {
            diffs[key] = item2;
            return;
        }
        if (type1 === '[object Object]') {
            var objDiff = diff(item1, item2);
            if (Object.keys(objDiff).length > 0) {
                diffs[key] = objDiff;
            }
            return;
        }
        if (type1 === '[object Array]') {
            if (!arraysMatch(item1, item2)) {
                diffs[key] = item2;
            }
            return;
        }
        if (type1 === '[object Function]') {
            if (item1.toString() !== item2.toString()) {
                diffs[key] = item2;
            }
        } else {
            if (item1 !== item2 ) {
                diffs[key] = item2;
            }
        }

    };


    for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            compare(obj1[key], obj2[key], key);
        }
    }

    for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (!obj1[key] && obj1[key] !== obj2[key] ) {
                diffs[key] = obj2[key];
            }
        }
    }

    return diffs;

};
